<template>
    <rkm-area
        title="Reagendar exame - Lançamento de coleta"
        type="fieldset"
    >
        <Form :data="data" />
    </rkm-area>
</template>

<script>

// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
    },
}
</script>